<template>
  <div class="visitor-management">
    <div class="checkin_title">访客管理 / 访客申请</div>
    <div class="container">
      <!-- 通行方式配置卡片 -->
      <el-card class="config-card" shadow="never">
        <div slot="header" class="clearfix">
          <span class="card-title">到访通行</span>
          <span class="card-subtitle">
            访客通行方式开启后，自助预约/成员邀约访客可使用该通行凭证
          </span>
        </div>
        <div class="config-card config-container">
          <div class="config-content">
            <!-- 二维码通行方式 -->
            <div class="config-item">
              <div class="config-label">
                <span class="label-text">二维码</span>
                <el-switch v-model="config.qrCode.enabled" @change="companySetting"></el-switch>
              </div>
<!--              <div class="config-desc">
                <el-checkbox v-model="config.qrCode.autoCheckin" :disabled="!config.qrCode.enabled">
                  自动签到?
                </el-checkbox>
                <span class="desc-text" :class="{disabled: !config.qrCode.enabled}">
                  开启后，系统将在访客到访前1小时下发通行权限
                </span>
              </div>-->
            </div>

            <!-- 密码通行方式 -->
            <div class="config-item">
              <div class="config-label">
                <span class="label-text">密码</span>
                <el-switch v-model="config.password.enabled" @change="companySetting"></el-switch>
              </div>
<!--              <div class="config-desc">
                <el-checkbox v-model="config.password.autoCheckout" :disabled="!config.password.enabled">
                  自动签离
                </el-checkbox>
              </div>-->
            </div>

            <!-- 手机开门 -->
            <div class="config-item">
              <div class="config-label">
                <span class="label-text">人脸识别</span>
                <el-switch v-model="config.face.enabled" @change="companySetting"></el-switch>
              </div>
            </div>
            <!-- 访客机下发 -->
            <div class="config-item">
              <div class="config-label">
                <span class="label-text">卡片</span>
                <el-switch v-model="config.card.enabled" @change="companySetting" disabled></el-switch>
              </div>
              <div class="config-desc">
                <span class="desc-text" :class="{disabled: !config.card.enabled}">
                  开启后，系统将「身份证」作为「卡片」通行，需配置访客机使用
                </span>
              </div>
            </div>

            <!-- 短信通知 -->
            <div class="config-item">
              <div class="config-label">
                <span class="label-text">
                  短信通知
                  <el-tooltip class="item" effect="dark" :content="config.sms.enabled?'短信充值请联系管理员':'短信通知需联系管理员开启'" placement="top">
                      <i class="el-icon-info" style="cursor: pointer;color:gray;font-size: 1rem;margin-left: 5px;"></i>
                  </el-tooltip>
                </span>
                <el-switch v-model="config.sms.enabled" disabled></el-switch>
              </div>
              <div class="config-desc" v-if="config.sms.enabled">
                <span class="desc-text">
                  短信剩余： <span style="color:#009dff">{{config.sms.count || 0}} </span>条
                </span>
              </div>
            </div>

            <!-- 更多通行方式 -->
<!--            <div class="more-ways">
              <el-button type="text" icon="el-icon-more" @click="showMoreWays">
                更多通行方式
              </el-button>
            </div>-->
          </div>
          <div class="config-content config-qrcode">
            <div class="flex-container">
              <div class="centered-box">
                <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 企业邀约码 」</div>
                <div class="img">
                  <img v-if="qrcodeForm.companyQrcode" :src="`data:image/png;base64,${qrcodeForm.companyQrcode}`">
                  <span v-else>生成邀约码失败</span>
                </div>
                <el-button v-if="qrcodeForm.companyQrcode" type="primary" size="small" style="margin-top: 3px;"
                           @click="downloadCompanyQrCode(`data:image/png;base64,${qrcodeForm.companyQrcode}`,'企业邀约码')">下载邀约码</el-button>
              </div>
            </div>

            <div class="flex-container" style="margin-left: 30px;">
              <div class="centered-box">
                <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 企业员工邀约码 」</div>
                <div class="img">
                  <img v-if="qrcodeForm.memberQrcode" :src="`data:image/png;base64,${qrcodeForm.memberQrcode}`">
                  <span v-else>生成邀约码失败</span>
                </div>
                <el-button v-if="qrcodeForm.memberQrcode" type="primary" size="small" style="margin-top: 3px;"
                           @click="downloadCompanyQrCode(`data:image/png;base64,${qrcodeForm.memberQrcode}`,'企业员工邀约码')">下载邀约码</el-button>
              </div>
            </div>
          </div>
        </div>

      </el-card>

      <!-- 访客类型配置表格 -->
      <el-card class="type-table-card" shadow="never">
        <div slot="header" class="clearfix">
          <span class="card-title">访客类型配置</span>
          <el-button type="primary" icon="el-icon-plus" class="add-btn" @click="addVisitorType">
            添加
          </el-button>
        </div>

        <el-table
            :data="visitorTypes"
            style="width: 100%"
            class="visitor-type-table"
            height="calc(100vh - 48rem)"
            :header-cell-style="{background: '#f5f7fa', color: '#606266'}">
          <el-table-column
              prop="name"
              label="访客类型（权限组）"
              width="180">
          </el-table-column>
          <el-table-column
              prop="device"
              show-overflow-tooltip
              label="通行设备">
            <template slot-scope="scope">
              <el-tag v-for="item in scope.row.deviceList"
                      :key="item.id"
                      :closable="false"
                      style="margin-right: 5px;"
                      disable-transitions>
                {{item.name}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              width="120">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  @click="editVisitorType(scope.row)">
                编辑
              </el-button>
              <el-button
                  type="text"
                  style="color: #f56c6c;"
                  @click="deleteVisitorType(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 高级设置链接 -->
        <div class="advanced-settings">
          <div class="newpagination" v-if="total > 0">
            <div class="newpagination_text">共 {{ total }} 条数据</div>
            <el-pagination
                layout="prev, pager, next"
                :total="total"
                :current-page="visitorTypeQuery.pageNum"
                :page-size="20"
                @current-change="handleChangeVisitorType"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>

      <!-- 添加/编辑访客类型对话框 -->
      <el-drawer
          :title="dialogTitle"
          custom-class="dialog_device common_drawer" direction="rtl"
          :visible.sync="dialogVisible"
          :showClose="false" :wrapperClosable="false"
          width="500px">
        <span slot="title" class="dialog_title">
          <i class="el-icon-close icon-close" @click="dialogVisible = false"></i>
          <span class="dialog_t">{{dialogTitle}}</span>
          <div class="dialog_confirm">
            <el-button class="add-confirm_a" @click="dialogVisible = false" style="background: none">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="saveVisitorType" class="add-confirm_a">确认</el-button>
          </div>
        </span>
        <div style="padding: 10px;">
          <el-form :model="visitorTypeForm" label-width="80px"
                   label-position="top" ref="spaceForm"
                   :rules="rules"
          >
            <el-form-item label="名称">
              <el-input v-model="visitorTypeForm.name" placeholder="请输入访客类型名称"></el-input>
            </el-form-item>
            <el-form-item label="通行设备">
              <div style="width: 100%;display: flex;color:gray;">
                <div class="access" @click="handleDeviceClick">
                  <div  class="placeholder" v-if="visitorTypeForm.deviceList.length==0"> 请选择 </div>
                  <div class="wrap" v-else>
                    <div class="wrap_item">{{ visitorTypeForm.deviceList.length>0?visitorTypeForm.deviceList[0]?.name:'' }}</div>
                    <div class="wrap_item" v-if="visitorTypeForm.deviceList.length>1">+{{ visitorTypeForm.deviceList.length-1 }}</div>
                  </div>
                  <i class="el-icon-circle-plus-outline" style="font-size: 14px;"></i>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
    <company-footer-info />
    <device-space-select-dialog ref="deviceSpaceSelectDialog" @confirm="handleDeviceConfirm"/>
  </div>
</template>

<script>
import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
import {VisitorApplyApi} from "@/api/server/visitorApply";
import {CompanyApi} from "@/api/server/company";
import {VisitorTypeApi} from "@/api/server/visitorType";
import DeviceSpaceSelectDialog from "@/views/device/components/device-space-select-dialog.vue";
export default {
  name: 'VisitorManagement',
  components: {CompanyFooterInfo,DeviceSpaceSelectDialog},
  data() {
    return {
      // 通行方式配置
      config: {
        qrCode: {
          enabled: true,
        },
        password: {
          enabled: true,
        },
        face: {
          enabled: true
        },
        card: {
          enabled: false
        },
        sms: {
          enabled: false,
          count: 5
        }
      },
      qrcodeForm:{},
      // 访客类型数据
      visitorTypes: [

      ],
      total: 0,
      // 对话框控制
      dialogVisible: false,
      loading: false,
      dialogTitle: '添加访客类型',
      visitorTypeForm: {
        name: '',
        deviceIds: [],
        deviceList: []
      },
      visitorTypeQuery: {
        name: '',
        pageNum: 1,
        pageSize: 10
      },
      rules: {
        name: [
          {required: true, message: '请输入访客类型名称', trigger: 'blur'}
        ]
      },
    };
  },
  mounted() {
    this.generateQrcode();
    this.queryCompanyInfo();
    this.getVisitorTypePage();
  },
  methods: {
    generateQrcode(){
      VisitorApplyApi.generateQrcode().then(response => {
        const {code,data} = response;
        if(code == 200){
          this.qrcodeForm = data || {};
        }
      })
    },
    base64ToBlob(base64Str, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512
      const byteCharacters = atob(base64Str.split(',')[1])
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }
      const blob = new Blob(byteArrays, { type: contentType })
      return blob
    },
    downloadCompanyQrCode(img,filename) {
      const blob = this.base64ToBlob(img, 'image/png')
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = filename;
      document.body.appendChild(link)
      link.click()
      // 清理
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    getVisitorTypePage() {
      VisitorTypeApi.getVisitorTypePage(this.visitorTypeQuery).then(response => {
        const {code,data} = response;
        if(code == 200){
          this.visitorTypes = data.list || [];
          this.total = data.total || 0;
        }
      })
    },
    handleChangeVisitorType(val){
      this.visitorTypeQuery.pageNum = val;
      this.getVisitorTypePage();
    },
    // 添加访客类型
    addVisitorType() {
      this.dialogTitle = '添加访客类型';
      this.visitorTypeForm = {
        name: '',
        deviceIds: [],
        deviceList: []
      };
      this.dialogVisible = true;
    },
    handleDeviceClick(){
      this.$refs.deviceSpaceSelectDialog.show(this.visitorTypeForm.deviceList);
    },
    handleDeviceConfirm(list){
      this.visitorTypeForm.deviceIds = list.map(d => d.id);
      this.visitorTypeForm.deviceList = list;
    },
    // 编辑访客类型
    editVisitorType(row) {
      this.dialogTitle = '编辑访客类型';
      this.visitorTypeForm = {...row};
      this.visitorTypeForm.deviceIds = row.deviceList?.map(d => d.id) || [];
      this.dialogVisible = true;
    },

    // 删除访客类型
    deleteVisitorType(row) {
      this.$confirm(`确认删除访客类型吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        VisitorTypeApi.deleteById(row.id).then(response => {
          if(response.code == 200){
            this.$message.success("删除成功");
            this.getVisitorTypePage();
          }else{
            this.$message.error(response.message || '删除失败');
          }
        })
      }).catch(() => {
        // 用户取消删除
      });
    },

    // 保存访客类型
    saveVisitorType() {
      this.$refs.spaceForm.validate(valid => {
        if (valid) {
          this.loading = true;
          VisitorTypeApi.save(this.visitorTypeForm).then(response => {
            if(response.code == 200){
              this.$message.success("保存成功");
              this.dialogVisible = false;
              this.getVisitorTypePage();
            }else{
              this.$message.error(response.message || '保存失败');
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      });
    },
    queryCompanyInfo(){
      CompanyApi.queryCurrentCompany().then(response => {
        let {code, data} = response;
        if (code == 200) {
          this.config.sms.enabled = data?.enabledSms || false;
          this.config.card.enabled = data?.enabledCard || false;
          this.config.qrCode.enabled = data?.enabledQrcode || false;
          this.config.password.enabled = data?.enabledPassword || false;
          this.config.face.enabled = data?.enabledFace || false;
          this.config.sms.count = data?.smsCount || 0;
        }
      });
    },
    companySetting(){
      const data = {
        enabledSms: this.config.sms.enabled ,
        enabledFace: this.config.face.enabled,
        enabledQrcode: this.config.qrCode.enabled,
        enabledPassword: this.config.password.enabled,
        enabeledCard: this.config.card.enabled,
      }
      if(!(data.enabledQrcode || data.enabledPassword || data.enabledFace)){
        this.$message.error('二维码/人脸/密码必须开启至少一种。');
        this.queryCompanyInfo();
        return;
      }
      CompanyApi.companySetting(data).then(response => {
        let {code, message} = response;
        if (code == 200) {
          this.$message.success('修改成功');
        } else {
          this.$message.error(message || '修改失败');
        }
        this.queryCompanyInfo();
      })
    }
  }
};
</script>

<style scoped>
.visitor-management {
  font-family: 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background-color: #f5f7fa;
  padding: 15px;
  box-sizing: border-box;
  height: 100%;
}

.container {
  width: 100%;
  height: calc(100% - 60px);
  margin: 0 auto;
}

.checkin_title {
  font-size: 14px;
  color: #5c5c5c;
  margin-bottom: 10px;
}

.help-link {
  font-size: 14px;
  color: #409eff;
}

.config-card, .type-table-card {
  margin-bottom: 10px;

}

.config-container {
  display: flex;
  justify-content: space-between;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.card-subtitle {
  font-size: 14px;
  color: #909399;
  margin-left: 10px;
}

.config-content {
  width: 50%;
  border: 1px solid #e4e7ed;
  padding: 20px;
  border-radius: 5px;
}

.config-qrcode {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.config-item {
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.config-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.config-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.label-text {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
}

.config-desc {
  display: flex;
  align-items: center;
}

.desc-text {
  font-size: 14px;
  color: #909399;
  margin-left: 10px;
}

.desc-text.disabled {
  color: #c0c4cc;
}

.more-ways {
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid #ebeef5;
}

.add-btn {
  float: right;
  padding: 8px 15px;
}

.visitor-type-table {
  margin-bottom: 10px;
}

.advanced-settings {
  text-align: right;
  border-top: 1px solid #ebeef5;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .container {
    padding: 10px;
  }

  .header {
    flex-direction: column;
    align-items: flex-start;
  }

  .header h2 {
    margin-bottom: 10px;
  }

  .config-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .config-label {
    width: 100%;
    margin-bottom: 12px;
  }

  .config-desc {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  .desc-text {
    margin-left: 0;
    margin-top: 8px;
  }
}

.visitor_qrcode_but span{
  margin-left: 10px;
}
.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.centered-box {
  flex:1;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  background: #fff;
  /*border: 1px solid #DCDFE6;*/
  text-align: center;
  min-width: 260px;
  height: 260px;
  width: 100%;
}
.flex-container .centered-box .img{
  border-radius: 12px;
  border: 1px solid #ebeef5;
  padding: 10px;
  text-align: center;
  display: inline-block; /* 或 display: block; 然后使用 margin: 0 auto; */
  margin: 0 auto;
  width: 70%;
  height: 70%;
}
.flex-container .centered-box .img span{
  line-height: 180px;
  color: #e35d5d;
}
.flex-container .centered-box .img img{
  width: 100%;
  height: 100%;

}

.dialog_title {
  display: flex;
  align-items: center;
  color: #1a1a1a;
}

.dialog_t {
  font-size: 18px;
  margin-left: 20px;
}

.form_device {
  margin-left: 30px;
  margin-top: 30px;
}
.icon-close {
  font-size: 24px;
  cursor: pointer;
  color: #7e84a3;
}
.dialog_confirm {
  margin: 0 0 0 auto;
  font-size: 15px;
}
.access{
  width: 100%;
  border: 1px solid #e9eaef;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  height: 32px;
  cursor: pointer;
}
.access .wrap{
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
}
.access .wrap_item{
  padding: 5px 0.5rem 0px 0.5rem;
  color: #3172f6;
  background: rgba(64, 158, 255, .12);
  border-radius: 2px;
  margin-right: 8px;
  height: 20px;
  line-height: 1;
  max-width: 88%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>